// extracted by mini-css-extract-plugin
export default {"modalBody":"alert-modal_modalBody__RIdPy","name":"alert-modal_name__m3qe1","button":"alert-modal_button__vbdUI"};